import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import WrapperFromCore from "core/Components/Wrapper";

type Props = {
    children: React.ReactNode
};

const Wrapper: React.FC<Props> = ({ children }) => {
    const theme: Theme = useTheme();

    const wrapperStyle = css`
        flex-direction: column;
        align-items: start;
        padding: 106px 88px;

        ${theme.breakpoints.up("5xl")} {
            padding: 177px 281px;
        }

        ${theme.breakpoints.between("3xl", "4xl")} {
            padding: 91px 141px;
        }

        ${theme.breakpoints.only("xl")} {
            padding: 100px 80px;
        }

        ${theme.breakpoints.only("lg")} {
            padding: 48px 64px;
        }

        ${theme.breakpoints.only("md")} {
            padding: 53px 59px;
        }

        ${theme.breakpoints.only("sm")} {
            padding: 42px 59px;
        }

        ${theme.breakpoints.down("xs")} {
            padding: 17px 20px;
        }
    `;

    return (
        <WrapperFromCore css={wrapperStyle}>
            {children}
        </WrapperFromCore>
    );
}

export default Wrapper;
